export default __webpack_public_path__ + "static/media/tv2.660c4dd0.jpeg";